// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"saltSum_flex__6uv1n","orange":"saltSum_orange__8_7NK","pulse":"saltSum_pulse__UK5iD"};